import Api from "../../utils/config/api";
import { toastr } from "react-redux-toastr";
import {
  SET_NEW_RETURN_LOST_CUST,
  SET_SNAPSHOT_DATA,
  SET_KYC_DATA,
  SET_CUSTOMERS_LIST,
  SET_CUSTOMERS_ACTIVITY,
  GET_A_CUSTOMER_ACTIVITY,
  GET_CUSTOMERS_SEGMENT,
  GET_CUSTOMERS_TABLE_SEGMENT,
  GET_DYNAMINC_FILTER_VALUES,
  RESET_CUST_STATE,
} from "../types";

export const getNewReturnLostCall =
  (id, period, start, end, isAllStores) => (dispatch) => {
    const url = isAllStores
      ? `/v1/groups/${id}/customer/new-return-lost?period=${period}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}`
      : `/v1/insights/${id}/customer/new-return-lost?period=${period}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}`;
    return new Promise((resolve, reject) => {
      Api.get(url)
        .then((res) => {
          dispatch({
            type: SET_NEW_RETURN_LOST_CUST,
            payload: res?.data?.payload,
          });

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.status !== 401 &&
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );
          return reject(err);
        });
    });
  };

export const getSnapShotCall =
  (id, period, start, end, isAllStores) => (dispatch) => {
    const url = isAllStores
      ? `/v1/groups/${id}/customer/snapshot?period=${period}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}`
      : `/v1/insights/${id}/customer/snapshot?period=${period}${
          (start && `&start=${start}`) || ""
        }${(end && `&end=${end}`) || ""}`;
    return new Promise((resolve, reject) => {
      Api.get(url)
        .then((res) => {
          dispatch({
            type: SET_SNAPSHOT_DATA,
            payload: res?.data?.payload,
          });

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.status !== 401 &&
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );
          return reject(err);
        });
    });
  };

export const exportSnapShotCall = (id, period, start, end) => {
  return new Promise((resolve, reject) => {
    const url = `/v1/groups/${id}/customer/snapshot?period=${period}${
      (start && `&start=${start}`) || ""
    }${(end && `&end=${end}&attachment=true`) || ""}`;

    Api.get(url)
      .then((res) => resolve(res.data))
      .catch((err) => {
        toastr.error(
          "Error",
          err?.response?.data?.message || "Something went wrong!"
        );

        return reject(err?.response?.data?.message);
      });
  });
};

export const getKycDataCall = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/${storeId}/customer/kyc`)
      .then((res) => {
        dispatch({
          type: SET_KYC_DATA,
          payload: res?.data?.payload,
        });

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getCustomerListCall =
  (
    data,
    storeId,
    period,
    customer_filter,
    sortBy,
    search,
    page,
    start,
    end,
    channel,
    groupId,
    lastVisitedFilter,
    firstVisitedFilter,
    is_life_time_date
  ) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.post(
        `/v1/insights/${storeId}/customer/list${
          page &&
          `?page=${page || 1}${groupId ? `&group_id=${groupId}` : ""}${
            period ? `&period=${period}` : ""
          }${customer_filter ? `&customer_filter=${customer_filter}` : ""}${
            sortBy?.length > 0 ? `&sort=${sortBy}` : ""
          }${search && `&search=${search}`}${
            (start && `&start=${start}`) || ""
          }${(end && `&end=${end}`) || ""}${
            (channel && `&channel=${channel}`) || ""
          }${
            (lastVisitedFilter &&
              `&last_visited_filter=${lastVisitedFilter}`) ||
            ""
          }${
            (firstVisitedFilter &&
              `&first_visited_filter=${firstVisitedFilter}`) ||
            ""
          }${
            typeof is_life_time_date === "boolean"
              ? `&is_life_time_date=${is_life_time_date}`
              : ""
          }`
        }`,
        data
      )
        .then((res) => {
          dispatch({
            type: SET_CUSTOMERS_LIST,
            payload: res?.data?.payload,
          });

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.status !== 401 &&
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );
          return reject(err);
        });
    });
  };

export const getCustomerListNewCall = (data, query) => () => {
  const store_id = query?.store_id,
    period = query?.period || "",
    customer_filter = query?.customer_filter || "",
    sortBy = query?.sortBy || "",
    search = query?.search || "",
    page = query?.page || 1,
    start = query?.start || "",
    end = query?.end || "",
    channel = query?.channel || "",
    group_id = query?.group_id || "",
    last_visited_filter = query?.last_visited_filter || "",
    first_visited_filter = query?.first_visited_filter || "",
    is_life_time_date = query?.is_life_time_date;

  const url = `/v1/insights/${store_id}/customer/list${
    page &&
    `?page=${page || 1}${group_id ? `&group_id=${group_id}` : ""}${
      period && `&period=${period}`
    }${customer_filter && `&customer_filter=${customer_filter}`}${
      sortBy && `&sort=${sortBy}`
    }${search && `&search=${search}`}${start && `&start=${start}`}${
      end && `&end=${end}`
    }${(channel && `&channel=${channel}`) || ""}${
      (last_visited_filter && `&last_visited_filter=${last_visited_filter}`) ||
      ""
    }${
      first_visited_filter
        ? `&first_visited_filter=${first_visited_filter}`
        : ""
    }${
      typeof is_life_time_date === "boolean"
        ? `&is_life_time_date=${is_life_time_date}`
        : ""
    }`
  }`;

  return new Promise((resolve, reject) => {
    Api.post(url, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const exportCustomerCall = (data, query) => () => {
  const store_id = query?.store_id,
    period = query?.period || "",
    customer_filter = query?.customer_filter || "",
    sortBy = query?.sortBy || "",
    search = query?.search || "",
    page = query?.page,
    start = query?.start || "",
    end = query?.end || "",
    channel = query?.channel || "",
    group_id = query?.group_id || "",
    last_visited_filter = query?.last_visited_filter || "",
    first_visited_filter = query?.first_visited_filter || "",
    is_life_time_date = query?.is_life_time_date;

  const url = `/v1/insights/${store_id}/customer/list${
    page &&
    `?page=${page || 1}${group_id ? `&group_id=${group_id}` : ""}${
      period && `&period=${period}`
    }${customer_filter && `&customer_filter=${customer_filter}`}${
      sortBy && `&sort=${sortBy}`
    }${search && `&search=${search}`}${start && `&start=${start}`}${
      end && `&end=${end}`
    }${(channel && `&channel=${channel}`) || ""}${
      (last_visited_filter && `&last_visited_filter=${last_visited_filter}`) ||
      ""
    }${
      first_visited_filter
        ? `&first_visited_filter=${first_visited_filter}`
        : ""
    }${
      typeof is_life_time_date === "boolean"
        ? `&is_life_time_date=${is_life_time_date}`
        : ""
    }`
  }`;

  return new Promise((resolve, reject) => {
    Api.post(url, { ...data, attachment: true })
      .then((res) => {
        return resolve(res);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const checkCustomerPresence = (entityId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/${entityId}/customer-presence`)
      .then((res) => {
        return resolve(res?.data?.payload?.is_customers_present || false);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getCustomer = (storeId, custId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/${storeId}/customer/${custId}`)
      .then((res) => {
        return resolve(res?.data?.payload?.persona);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const updateACustomerActivity = (data) => (dispatch) => {
  dispatch({
    type: GET_A_CUSTOMER_ACTIVITY,
    payload: data,
  });
};

export const getACustomerActivity =
  (id, custId, page, belongs_to, isHitGrpApi) => (dispatch) => {
    const url = isHitGrpApi
      ? `/v1/groups/${id}/customer/persona/activity/${custId}?page=${page}&belongs_to=${belongs_to}`
      : `/v1/insights/${id}/customer/persona/activity/${custId}?page=${page}&belongs_to=${belongs_to}`;

    return new Promise((resolve, reject) => {
      Api.get(url)
        .then((res) => {
          dispatch({
            type: GET_A_CUSTOMER_ACTIVITY,
            payload: res?.data?.payload,
          });

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.status !== 401 &&
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );
          return reject(err);
        });
    });
  };

export const getCustomerSearchResults = (entityId, page, limit, search) => {
  const url = `/v1/insights/${entityId}/find-customer?page=${page}&limit=${limit}&search=${search}`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getCustomerActivityCall = (query) => (dispatch) => {
  const page = query?.page || 1;
  const status = query?.status || "";
  const entityId = query?.entityId || "";
  const isBlocked = query?.isBlocked || "";
  const isAllStores = query?.isAllStores || "";
  const customer_id = query?.customer_id || "";
  const isDontDispatch = query?.isDontDispatch || false;
  const orderType =
    query?.orderType === "all"
      ? ""
      : query?.orderType?.length > 0
      ? query?.orderType
      : "";

  const isExportQuery = query?.isAttachment || false;

  const period = query.period?.key;
  const end = query.period?.endDate?.format("YYYY-MM-DD");
  const start = query.period?.startDate?.format("YYYY-MM-DD");

  const url = `/v1/${
    isAllStores ? "groups" : "insights"
  }/${entityId}/customer/activity?filter=${status}${
    customer_id ? `&customer_id=${customer_id}` : ""
  }&page=${page}&period=${period}&start=${start}&end=${end}${
    isExportQuery ? "&attachment=true" : ""
  }${
    isBlocked === "false" || isBlocked === "true"
      ? `&is_blocked=${isBlocked}`
      : ""
  }${orderType?.length > 0 ? `&order_type=${orderType}` : ""}`;

  return new Promise((resolve, reject) => {
    Api.get(url)
      .then((res) => {
        if (isExportQuery) return resolve(res);
        else if (isDontDispatch) return resolve(res?.data?.payload);
        else {
          dispatch({
            type: SET_CUSTOMERS_ACTIVITY,
            payload: res?.data?.payload,
          });

          return resolve(res?.data?.payload);
        }
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getCustomerSegments = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/segments/${storeId}`)
      .then((res) => {
        dispatch({
          type: GET_CUSTOMERS_SEGMENT,
          payload: res?.data?.payload,
        });

        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getCustomerTableSegments = (storeId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/segments/compare/${storeId}`)
      .then((res) => {
        dispatch({
          type: GET_CUSTOMERS_TABLE_SEGMENT,
          payload: res?.data?.payload?.segments,
        });

        return resolve(res?.data?.payload?.segments);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Something went wrong!"
          );
        return reject(err);
      });
  });
};

export const getDynamicFilterValues =
  (id, data = {}) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      Api.post(`/v1/insights/${id}/customers/overview`, data)
        .then((res) => {
          dispatch({
            type: GET_DYNAMINC_FILTER_VALUES,
            payload: res?.data?.payload,
          });

          return resolve(res?.data?.payload);
        })
        .catch((err) => {
          err?.response?.status !== 401 &&
            toastr.error(
              "Error",
              err?.response?.data?.message || "Something went wrong!"
            );
          return reject(err);
        });
    });
  };

export const getFileKeyCall = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/utility/file-upload`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        if (err?.response?.status === 413) {
          toastr.error(
            "Upload Failed",
            err?.response?.data?.message ||
              "The file that you've uploaded is too large. You can import maximum 100,000 customers in 1 file."
          );
          return reject(err);
        } else if (err?.response?.status === 422) {
          err?.response?.data?.errors?.map((errObj) =>
            toastr.error("Upload Failed", errObj.msg)
          );
          return reject(err);
        } else {
          toastr.error(
            "Upload Failed",
            err?.response?.data?.message || "Failed to get upload key for file!"
          );
          return reject(err);
        }
      });
  });
};

// import customers
export const checkImportCustomerStatus = (storeId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/stores/${storeId}/check-import-customer-status`)
      .then((res) => resolve(res?.data))
      .catch((err) => {
        if (err?.response?.status !== 401)
          toastr.error(
            "Error",
            err?.response?.data?.message || "Failed to check import status !"
          );

        return reject(err);
      });
  });
};

export const sendFileDetailsCall = (storeId, data) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/stores/${storeId}/import-customer`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Failed to import customer data!"
          );
        return reject(err);
      });
  });
};

export const getImportedCustLogs = (storeId, page) => () => {
  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/stores/${storeId}/import-customer?${
        page ? `page=${page}` : "page=1"
      }`
    )
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to import customer logs data!"
          );
        return reject(err);
      });
  });
};

export const getUpdatedImportCustomer = (storeId, importId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/stores/${storeId}/import-customer?importId=${importId}`)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to get updated import status."
          );
        return reject(err);
      });
  });
};

export const getFailedCustomer = (storeId, importId) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/stores/${storeId}/import-customer/${importId}`)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to import customer logs data!"
          );
        return reject(err);
      });
  });
};

// import transactions
export const sendTrxnsCsvFile = (storeId, data) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/stores/${storeId}/import-customer`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Failed to import customer data!"
          );
        return reject(err);
      });
  });
};

export const getImportedTrxnsLogs = (storeId, page) => () => {
  return new Promise((resolve, reject) => {
    Api.get(
      `/v1/stores/${storeId}/import-loyalty-txns?${
        page ? `page=${page}` : "page=1"
      }`
    )
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to import customer logs data!"
          );
        return reject(err);
      });
  });
};

export const getUpdatedImportTrxn = (storeId, importId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/stores/${storeId}/import-loyalty-txns?importId=${importId}`)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to get updated import status."
          );
        return reject(err);
      });
  });
};

// Edit and delete points
export const getPointsForOrder = (storeId, orderId, data) => () => {
  return new Promise((resolve, reject) => {
    Api.post(`/v1/insights/${storeId}/orders/${orderId}/points`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to import customer logs data!"
          );
        return reject(err);
      });
  });
};

export const editPointsForOrder = (storeId, orderId, data) => () => {
  return new Promise((resolve, reject) => {
    Api.patch(`/v1/insights/${storeId}/orders/${orderId}/edit`, data)
      .then((res) => {
        toastr.success(
          "Success",
          `Current customer bill amount updated to ${res?.data?.payload?.updated_value}`
        );
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to import customer logs data!"
          );
        return reject(err);
      });
  });
};

export const deletePointsForOrder = (storeId, orderId) => () => {
  return new Promise((resolve, reject) => {
    Api.delete(`/v1/insights/${storeId}/orders/${orderId}/edit`)
      .then((res) => {
        toastr.success("Points Delete successfully");
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.response?.message ||
              err?.response?.data?.message ||
              "Failed to import customer logs data!"
          );
        return reject(err);
      });
  });
};
// customer tags
export const searchExistingTags = (entityId, search) => () => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/customer/tags/${entityId}?query=${search}`)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        toastr.error("Error", "Failed to search tags.");
        return reject(err);
      });
  });
};

export const createNewTag = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/insights/customer/tag/create-tag`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error("Error", "Failed to create customer tag.");
        return reject(err);
      });
  });
};

export const addOrUpdateCustomerTags = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/insights/customer/tag/add-tag`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error("Error", "Failed to add or update tags.");
        return reject(err);
      });
  });
};

export const deleteCustomerTags = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.delete(`/v1/insights/customer/delete-tag`, { data })
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error("Error", "Failed to remove existing tags.");
        return reject(err);
      });
  });
};

export const toggleBlockCustomerAction = (data) => () => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/insights/customer/block-unblock`, data)
      .then((res) => {
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        toastr.error(
          "Error",
          `Failed to ${data?.block ? "block" : "unblock"} this customer.`
        );
        return reject(err);
      });
  });
};

export const removeCustomerFromFraudListAction = (storeId, customerId) => {
  return new Promise((resolve, reject) => {
    Api.put(`/v1/insights/${storeId}/update-fraud-status/${customerId}`, {
      remove_from_fraud: true,
    })
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        toastr.error("Error", `Failed to remove customer from fraud.`);
        return reject(err);
      });
  });
};

export const getNewPosMenuCall = (query) => {
  const page = query?.page || 1;
  const limit = query?.limit || 20;
  const entityId = query?.entityId;

  const item = query?.item; // name of item, when searching with item name
  const category = query?.category; // name of category, when searching with category name
  const is_category = query?.is_category || false; // when true this will get categories only.
  const category_ids = query?.category_ids; // list of category_ids
  const category_ids_joined = category_ids?.join(","); // joined category_ids

  const endpoint = `/v1/insights/${entityId}/pos-menu?page=${page}&limit=${limit}&is_category=${is_category}${
    item?.length > 0 ? `&item=${item}` : ""
  }${category?.length > 0 ? `&category=${category}` : ""}${
    category_ids?.length > 0 ? `&category_ids=${category_ids_joined}` : ""
  }`;

  return new Promise((resolve, reject) => {
    Api.get(endpoint)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        toastr.error("Error", `Failed to fetch pos menu.`);
        return reject(err);
      });
  });
};

export const getCustomerLifecycle = (entityId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/customer-life-cycle/${entityId}`)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Error",
            err?.response?.data?.errors?.join(", ") ||
              "Failed to get customer lifecycle."
          );
          return reject(err);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Failed to get customer lifecycle."
          );
          return reject(err);
        }
      });
  });
};

export const getASmartSegment = (segmentId) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/smart-segment/${segmentId}`)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Error",
            err?.response?.data?.errors?.join(", ") ||
              "Failed to get smart group."
          );
          return reject(err);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Failed to get smart group."
          );
          return reject(err);
        }
      });
  });
};

export const getSmartSegments = (entityId, page) => {
  return new Promise((resolve, reject) => {
    Api.get(`/v1/insights/smart-segments/${entityId}?page=${page}&limit=5`)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Error",
            err?.response?.data?.errors?.join(", ") ||
              "Failed to get smart group."
          );
          return reject(err);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message || "Failed to get smart group."
          );
          return reject(err);
        }
      });
  });
};

export const createOrUpdateSmartSegment = (query, data) => {
  const entityId = query?.entityId,
    segmentId = query?.segmentId || "";

  const url = `/v1/insights/smart-segment/${entityId}${
    segmentId?.length > 0 ? `?smart_segment_id=${segmentId}` : ""
  }`;

  return new Promise((resolve, reject) => {
    Api.post(url, data)
      .then((res) => resolve(res?.data?.payload))
      .catch((err) => {
        if (err?.response?.status === 422) {
          toastr.error(
            "Validation Error",
            err?.response?.data?.errors?.map((errObj) => errObj.msg).join(", ")
          );
          return reject(err?.response?.data?.errors);
        } else {
          toastr.error(
            "Error",
            err?.response?.data?.message ||
              "Failed to create/update smart group!"
          );

          return reject(err?.response?.data?.message);
        }
      });
  });
};

export const deleteSmartSegment = (segmentId) => {
  return new Promise((resolve, reject) => {
    Api.delete(`/v1/insights/smart-segment/${segmentId}`)
      .then((res) => {
        toastr.success("Smart group deleted successfully");
        return resolve(res?.data?.payload);
      })
      .catch((err) => {
        err?.response?.status !== 401 &&
          toastr.error(
            "Error",
            err?.response?.data?.message || "Failed to delete smart group!"
          );
        return reject(err);
      });
  });
};

export const resetCustState = () => (dispatch) => {
  dispatch({
    type: RESET_CUST_STATE,
  });
};
